/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { Row, Col, Form, Button, Select, Input, Spin, message } from "antd";
import { camelCase } from "../../../utils";
import moment from "moment";
import GenerateLcrModal from "./GenerateLcrModal";
import urls from "../../../api/urls";
import NormalAPI from "../../../api";
import API from "../../../api";
// import eligiblebagJson from "./Dummy data/eligibleBagsResponse.json";
import checkIcon from "../../../assests/images/SVG/check.svg";
import back_img from "../../../assests/images/rightVector.svg";
import "./style.scss";
const UpdateTrip = () => {
  const navigate = useNavigate();
  const history = useLocation();
  const [form] = Form.useForm();
  const { Option } = Select;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userId, setUserId] = useState();
  const [userName, setUserName] = useState();
  const [travellMode, setTravellMode] = useState();
  const [lcrBagsDest, setLcrBagsDest] = useState([]);
  const [lcrPayLoad, setLcrPayLoad] = useState();
  const [check, setCheck] = useState(false);
  // const [vehicleData, setVehicleData] = useState();
  const [ewayButtonVisible, setEwayButtonVisible] = useState(false);
  const [lcrNumr, setLcrNum] = useState([]);
  const [createTripBtnDesabled, setCreateTripBtnDesabled] = useState(false);
  const [allEligibleBags, setAllEligibleBags] = useState();
  const [driverName, setDriverName] = useState();
  const [coLoader, setCoLoader] = useState();
  const [flightNum, setFlightNum] = useState("");
  const [vehicleNum, setVehicleNum] = useState("");
  const [currentScanNum, setcurrentScanNum] = useState([]);
  const [currentScanIndex, setcurrentScanIndex] = useState([]);
  const [recoveredTripdata, setRecoveredTripdata] = useState({});
  const { POST_ELIGIBLE_BAGS, PATCH_CONSOLIDATED_LCR, GET_ROUT_BY_ID } = urls;

  let barcode = "";
  let interval;

  useEffect(() => {
    setUserId(JSON.parse(localStorage.getItem("userId")));
    setUserName(JSON.parse(localStorage.getItem("userName")));
    setEwayButtonVisible(false);
    setCreateTripBtnDesabled(false);
    setLcrNum([]);
    setTravellMode();
  }, []);
  useEffect(() => {
    if (history?.state) setRecoveredTripdata(history?.state);
  }, [history]);
  //
  useEffect(() => {
    if (recoveredTripdata?.premiseId) {
      routeByIdHandle();
      setTravellMode(recoveredTripdata?.travelBy?.toUpperCase());
      form.setFieldValue("modeOfTransport", recoveredTripdata?.travelBy);
      // form.setFieldValue("route", recoveredTripdata?.routeId);
      form.setFieldValue("tripId", recoveredTripdata?.tripId);
      form.setFieldValue("vehicleNo", recoveredTripdata?.vehicleNum);
      form.setFieldValue("driverName", recoveredTripdata?.driverName);
      form.setFieldValue("CoLoader", recoveredTripdata?.coloader);
      form.setFieldValue("flightNo", recoveredTripdata?.flightNum);
    }
  }, [recoveredTripdata]);
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  useEffect(() => {
    scannerHandle(currentScanNum);
  }, [currentScanNum]);
  useEffect(() => {
    let date = moment();
    let currentDate = date.format("DD/MM/YYYY");
    form.setFieldValue("date", currentDate);
  }, []);

  const patchApiTrigger = () => {
    if (recoveredTripdata?.vehicleLcrId) {
      patchLcr(+recoveredTripdata?.vehicleLcrId);
    }
  };
  const routeByIdHandle = async () => {
    let response = await API.Api(
      GET_ROUT_BY_ID + recoveredTripdata?.routeId
    ).getWithUserNPremiseHeader();
    form.setFieldValue(
      "route",
      response?.response?.data?.route?.map((item, index) =>
        index == response?.response?.data?.route?.length - 1
          ? camelCase(item?.hubName) + ""
          : camelCase(item.hubName) + " - "
      )
    );
  };
  const patchLcr = async (id) => {
    let responseEligibleBag = await NormalAPI.Api(
      PATCH_CONSOLIDATED_LCR + id
    ).patchIdHeader({
      status: "LOCKED",
      consolidatedLCRDtos: lcrNumr,
    });
    if (responseEligibleBag?.status) {
      navigate("/eway-update/" + recoveredTripdata?.tripId);
    }
  };
  const createTripHandle = async (e) => {
    setDriverName(e.driverName);
    setCoLoader(e.CoLoader);
    setFlightNum(e.flightNo);
    setVehicleNum(e.vehicleNo);
    // setVehicleData(recoveredTripdata?.vehicleLcrId);
    let responseEligibleBag = await NormalAPI.Api(
      `${POST_ELIGIBLE_BAGS}${recoveredTripdata?.tripId}/vehicle/${
        recoveredTripdata?.flightNum
          ? recoveredTripdata?.flightNum
          : recoveredTripdata?.vehicleNum
      }/eligible`
    ).postIdHeader();
    if (responseEligibleBag?.response?.data?.length > 0) {
      message.success("Bags fetched successfully");
      let temp = [];
      responseEligibleBag?.response?.data.map((e) => {
        temp.push({
          ...e,
          barcodes: e.barcodes.map((item) => ({
            barcode: item,
            status: false,
          })),
        });
      });
      setAllEligibleBags(temp);
      setCreateTripBtnDesabled(true);
    } else {
      message.error("No Bags found for this route");
      setTravellMode("");
      form.setFieldValue("modeOfTransport", "");
      form.setFieldValue("route", "");
      form.setFieldValue("CoLoader", "");
      form.setFieldValue("flightNo", "");
      form.setFieldValue("vehicleNo", "");
      form.setFieldValue("driverName", "");
    }
  };
  const ModeOfTransportHandle = (e) => {
    setTravellMode(e.toUpperCase());
    form.setFieldValue("CoLoader", "");
    form.setFieldValue("flightNo", "");
    form.setFieldValue("vehicleNo", "");
    form.setFieldValue("driverName", "");
  };
  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleBarcode(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };
  const handleBarcode = (scanned_barcode) => {
    setcurrentScanNum(parseInt(scanned_barcode));
  };
  const scannerHandle = (e) => {
    // let testData = lcrBagsDest;
    let testData = allEligibleBags;
    for (let i in testData) {
      let foundData = testData[i]?.barcodes?.find((item) => item?.barcode == e);
      if (foundData !== undefined) {
        let index = allEligibleBags[i]?.barcodes?.findIndex(
          (item) => item?.barcode == e
        );
        let tempIndex = allEligibleBags.findIndex((x)=>x.barcodes.some((item)=>item.barcode == e));
        setcurrentScanIndex(tempIndex);
        testData[i].barcodes[index] = {
          ...testData[i]?.barcodes[index],
          status: true,
        };
      }
      setLcrBagsDest(testData);
      setCheck(!check);
      let filteredTestData = testData?.map((data) =>
        data?.barcodes?.filter((data) => data?.status == true)
      );
      let x = [];
      filteredTestData?.map((data) => x.push(data));
    }
  };
  function handleCallBack(item) {
    let tempScannedLCRDto = [];
    item?.lcrShipmemtsDtos?.map((e)=>tempScannedLCRDto.push({barcode: e.awbNumber, status: true}));
    let temp = allEligibleBags;
    temp[currentScanIndex].barcodes = tempScannedLCRDto;
    setAllEligibleBags([...temp]);
    setEwayButtonVisible(true);
    setcurrentScanIndex(null);
    setCreateTripBtnDesabled(true);
  }
  const handleGenerateIndex = (idx, destinationHub) => {
    !isModalOpen ? setIsModalOpen(true) : setIsModalOpen(false);
    let lcrShipmemtsDtos = [];
    lcrBagsDest[idx].barcodes.map((item) => {
      if(item.status){
      if (lcrBagsDest[idx]?.bags?.includes(item.barcode)) {
        lcrShipmemtsDtos.push({
          awbNumber: item.barcode,
          bag: true,
        });
      }else if (lcrBagsDest[idx]?.childShipments?.includes(item.barcode))  {
        lcrShipmemtsDtos.push({
          awbNumber: item.barcode,
          childshipment: true,
        });
      } else {
        lcrShipmemtsDtos.push({
          awbNumber: item.barcode,
          shipment: true,
        });
      }
      }
    });
    setLcrPayLoad({
      hubUser: userName,
      toDate: "",
      fromHub: userId?.premises?.premiseName,
      toHub: destinationHub,
      toPremiseId: parseInt(lcrBagsDest[idx]?.destinationId.toString()),
      travelBy: travellMode,
      coloader: "own",
      vehicleNum: vehicleNum ? vehicleNum : flightNum,
      driverName: coLoader ? coLoader : driverName,
      status: "CREATED",
      lcrShipmemtsDtos: lcrShipmemtsDtos,
    });
  };
  const lcrNumber = (e) => {
    let obj = {
      lcrNum: e?.response?.data?.lcrNum,
    };
    setLcrNum([...lcrNumr, obj]);
  };

  return (
    <Spin spinning={false}>
      <div className="p-2">
        <div className="align-center mt-1 mb-1 ">
          <img
            src={back_img}
            onClick={() => navigate("/update-trip-list")}
            style={{ cursor: "pointer" }}
          />
          <p
            style={{
              margin: "0",
              paddingLeft: "5px",
              fontWeight: "700",
              fontSize: "18px",
              lineHeight: "32px",
              letterSpacing: "-0.25px",
              color: "#061624",
            }}
          >
            <b>Update Trip</b>
          </p>
        </div>
        <div className="lcr-modal-wrapper p-2">
          <Form
            layout={"vertical"}
            form={form}
            autoComplete="off"
            onFinish={createTripHandle}
          >
            <Row gutter={12}>
              <Col lg={12} md={12} xs={24} xl={12} sm={24}>
                <Form.Item label="Trip ID" name="tripId">
                  <Input disabled={true} />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} xs={24} xl={12} sm={24}>
                <Form.Item label="Date" name="date">
                  <Input disabled={true} />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} xs={24} xl={12} sm={24}>
                <Form.Item
                  label="Mode of Transport"
                  name="modeOfTransport"
                  rules={[
                    {
                      required: true,
                      message: "Enter Mode of Transport",
                    },
                  ]}
                >
                  <Select onChange={ModeOfTransportHandle} disabled={true}>
                    <Option value={"Air"}>Air</Option>
                    <Option value={"Surface"}>Surface</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={12} md={12} xs={24} xl={12} sm={24}>
                <Form.Item
                  label="Route"
                  name="route"
                  rules={[
                    {
                      required: true,
                      message: "Enter route",
                    },
                  ]}
                >
                  <Input disabled={true} />
                </Form.Item>
              </Col>
              {travellMode == "AIR" ? (
                <>
                  <Col lg={12} md={12} xs={24} xl={12} sm={24}>
                    <Form.Item
                      label="Flight No"
                      name="flightNo"
                      rules={[
                        {
                          required: true,
                          message: "Enter Flight No",
                        },
                      ]}
                    >
                      <Input disabled={true} />
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} xs={24} xl={12} sm={24}>
                    <Form.Item
                      label="Co-loader"
                      name="CoLoader"
                      rules={[
                        {
                          required: true,
                          message: "Enter Co-loader",
                        },
                      ]}
                    >
                      <Input disabled={true} />
                    </Form.Item>
                  </Col>
                </>
              ) : travellMode == "SURFACE" ? (
                <>
                  <Col lg={12} md={12} xs={24} xl={12} sm={24}>
                    <Form.Item
                      label="Vehicle No"
                      name="vehicleNo"
                      rules={[
                        {
                          required: true,
                          message: "Enter Vehicle No",
                        },
                      ]}
                    >
                      <Input disabled={true} />
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} xs={24} xl={12} sm={24}>
                    <Form.Item
                      label="Driver Name"
                      name="driverName"
                      rules={[
                        {
                          required: true,
                          message: "Enter Driver Name",
                        },
                      ]}
                    >
                      <Input disabled={true} />
                    </Form.Item>
                  </Col>
                </>
              ) : null}
            </Row>

            <div
              className="d-flex flex-end footer-btn"
              style={{ marginTop: "1rem" }}
            >
              {/* <Button
                htmlType="submit"
                className="btn-style save-btn btn-two"
                disabled={createTripBtnDesabled}
              >
                GET BAGS
              </Button> */}
              <Button
                className="save-btn"
                htmlType="submit"
                disabled={createTripBtnDesabled}
              >
                GET BAGS
              </Button>
            </div>
          </Form>
          <Row gutter={12} className="mt-1">
            {allEligibleBags?.map((data, index) => (
              <Col lg={12} md={12} xs={24} xl={8} sm={24} key={index}>
                <div className="bagOutscanCont p-1">
                  <Row>
                    <Col span={12}>
                      <b>Destination: </b>
                      <div> {camelCase(data?.destination)}</div>
                    </Col>
                    <Col span={12}>
                      <b>Mode: </b>
                      {camelCase(data?.mode)}
                    </Col>
                  </Row>
                  <Row className="mb-1 mt-1">
                    <Col span={12}>
                      <Button
                        className="save-btn"
                        onClick={() =>
                          handleGenerateIndex(index, data?.destination)
                        }
                        disabled={currentScanIndex !== index}
                      >
                        GENERATE LCR
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <div className="table-head">
                        <b>Bag ID / AWB No</b>
                      </div>
                      <div className="table-col-wrap">
                        {data?.barcodes?.map((item, index) => (
                          <div
                            className="table-column align-center"
                            key={"x_" + index}
                          >
                            <p>{item?.barcode}</p>
                            {item?.status ? <img src={checkIcon} /> : ""}
                          </div>
                        ))}
                      </div>
                    </Col>
                  </Row>
                  <GenerateLcrModal
                    setIsModalOpen={setIsModalOpen}
                    isModalOpen={isModalOpen}
                    lcrPayLoad={lcrPayLoad}
                    lcrNumber={lcrNumber}
                    handleCallBack={handleCallBack}
                    flightNum={flightNum}
                    coLoader={coLoader}
                  />
                  <Input
                    // onChange={scannerHandle}

                    onChange={(e) => {
                      // eslint-disable-next-line no-constant-condition
                      if (e.target.value.length > 6) {
                        setcurrentScanNum(
                          parseInt(e.target.value)
                          // data?.barcodes
                        );
                        setcurrentScanIndex(index);
                      }
                    }}
                  />
                </div>
              </Col>
            ))}
          </Row>

          {ewayButtonVisible ? (
            <div className="d-flex flex-end p-1 footer-btn">
              <Button
                htmlType="submit"
                className="btn-style save-btn btn-two"
                // disabled={!checks.every((v) => v === true)}
                onClick={() => {
                  patchApiTrigger();
                }}
              >
                E-WAY UPDATE
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </Spin>
  );
};

export default UpdateTrip;
